module.exports = __webpack_public_path__ + "static/eating-information.72c5b8ac.jpg";